import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var concurrentPromise = function concurrentPromise() {
  var promise;
  return function (func) {
    if (!promise) promise = func();
    return promise.then(function (value) {
      promise = null;
      return Promise.resolve(value);
    }).catch(function (error) {
      promise = null;
      throw error;
    });
  };
};

var ConcurrentPromiseMap = /*#__PURE__*/function () {
  function ConcurrentPromiseMap() {
    _classCallCheck(this, ConcurrentPromiseMap);

    _defineProperty(this, "_promises", {});
  }

  _createClass(ConcurrentPromiseMap, [{
    key: "resolve",
    value: function resolve(key, func) {
      var _this = this;

      if (!this._promises[key]) {
        this._promises[key] = func();
      }

      return this._promises[key].then(function (value) {
        _this._promises[key] = null;
        return Promise.resolve(value);
      }).catch(function (error) {
        _this._promises[key] = null;
        throw error;
      });
    }
  }]);

  return ConcurrentPromiseMap;
}();

export { ConcurrentPromiseMap, concurrentPromise };
